import { NSARouterMakerResult } from "namirasoft-account-react";
import { MaintenancePlanStatus } from "namirasoft-erp";
import { Component } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { }

export default class MaintenancePlanListPage extends Component<Props>
{
    override render()
    {
        return (
            <ErpLayout
                {...this.props}
                mode={ErpScopeMode.Filter}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.maintenance_plan(this.props),
                    list: {
                        ui: {
                            getRowAttributes: (row) =>
                            {
                                if (row.status === MaintenancePlanStatus.Overdue)
                                    return { style: { backgroundColor: "#fdecea" } };
                                if (row.status === MaintenancePlanStatus.Warning)
                                    return { style: { backgroundColor: "#fff4e5" } };
                                if (row.status === MaintenancePlanStatus.Ok)
                                    return { style: { backgroundColor: "#e6f4ea" } };
                                return {};
                            },
                        },
                    },
                }}
            ><></></ErpLayout>
        );
    }
}